export default __webpack_public_path__ + "static/visually3-e9d81c4e781e2c23c09a2680945c4c57.png";